import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ee98abc6"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["onClick"];
const _hoisted_2 = { class: "item" };
import { computed, ref } from 'vue';
import { AppStore } from '@apparatix/stores/AppStore';
const COLLAPSE_AFTER_MOUSE_LEAVE = 750; // unit is ms
export default /*#__PURE__*/ _defineComponent({
    __name: 'Sidebar',
    props: {
        width: {},
        enableCollapse: { type: Boolean }
    },
    emits: ["sidebarCollapsed"],
    setup(__props, { emit: __emit }) {
        _useCssVars(_ctx => ({
            "44f515c6": (_ctx.width)
        }));
        const emit = __emit;
        const props = __props;
        const timeoutId = ref();
        const shouldCollapse = ref(true);
        const boxShadowStyle = computed(() => {
            const common = { position: 'absolute' };
            if (shouldCollapse.value && props.enableCollapse) {
                const shadow = { boxShadow: '-4px 0px 8px -4px var(--black-8) inset' };
                return { ...common, ...shadow };
            }
            if (!shouldCollapse.value && props.enableCollapse) {
                const shadow = { boxShadow: '0 0 12px 0 var(--black-15)' };
                return { ...common, ...shadow };
            }
            return { boxShadow: 'none' };
        });
        const onMouseEnter = () => {
            if (!props.enableCollapse)
                return;
            shouldCollapse.value = false;
            emit('sidebarCollapsed', false);
            if (typeof timeoutId.value === 'number') {
                window.clearTimeout(timeoutId.value);
            }
        };
        const onMouseLeave = () => {
            if (!props.enableCollapse)
                return;
            timeoutId.value = window.setTimeout(() => {
                shouldCollapse.value = true;
                emit('sidebarCollapsed', true);
            }, COLLAPSE_AFTER_MOUSE_LEAVE);
        };
        return (_ctx, _cache) => {
            return (_unref(AppStore).shouldShowSidebar)
                ? (_openBlock(), _createElementBlock("section", {
                    key: 0,
                    class: "sidebar",
                    style: _normalizeStyle(boxShadowStyle.value),
                    onMouseenter: onMouseEnter,
                    onMouseleave: onMouseLeave
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(AppStore).activeChildren, (item, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: idx,
                            class: _normalizeClass({ active: _unref(AppStore).activeSubPage.label === item.label }),
                            onClick: item.command
                        }, [
                            _createElementVNode("div", _hoisted_2, _toDisplayString(item.isHomePage ? 'Home' : item.label), 1)
                        ], 10, _hoisted_1));
                    }), 128))
                ], 36))
                : _createCommentVNode("", true);
        };
    }
});
